import './ccf-tags-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfTagsIconProps extends SvgIconProps {}

/**
 *
 * @param props - CcfTagsIcon
 * @example <CcfTagsIcon />
 * @returns
 */
export function CcfTagsIcon(props: CcfTagsIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M19 0H11.7C11.4 0 11.2 0.1 11 0.3L0.3 10.9C0.1 11.1 0 11.4 0 11.7C0 12 0.1 12.2 0.3 12.4L7.6 19.7C7.8 19.9 8.1 20 8.3 20C8.5 20 8.8 19.9 9 19.7L19.7 9.1C19.9 8.9 20 8.6 20 8.3V1C20 0.4 19.6 0 19 0ZM18 7.9L8.3 17.6L2.4 11.7L12.1 2H18V7.9Z"
        fill="#FF9400"
      />
      <path
        d="M16 6C16 7.105 15.105 8 14 8C12.895 8 12 7.105 12 6C12 4.895 12.895 4 14 4C15.105 4 16 4.895 16 6Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfTagsIcon;
